/**
 * @flow
 * @format
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import {
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

import actions from '~/routines/design';
import type { Record } from '~/modules/design/types';
import { FileManagement } from '../FileManagement/FileManagement';

import classes from './OpenDesignModal.scss';

type PropsType = {
  data: Map<number, Record>,
  onHide(): void,
  onOpenDesign(id: number): void,
  onRenameDesign({ id: number, name: string }): void,
  onCopyDesign({ id: number, name: string }): void,
  onDeleteDesign(id: number): void,
  show: boolean,
  loading: boolean,
};

export class OpenDesignModal extends React.PureComponent<PropsType, *> {
  static defaultProps = {};

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const toggle = this.props.onHide;

    const handleOnOpen = (id: number) => {
      this.props.onHide();
      this.props.onOpenDesign(id);
    };

    const handleRename = (id: number) => {
      const record = this.props.data.get(id);
      if (!record) return;
      const name = prompt('New design name', record.name || 'Unititled');

      if (name === null) return;

      const nameExists =
        name &&
        Array.from(this.props.data).some(
          ([, r]) => r.name.toUpperCase() === name.trim().toUpperCase(),
        );

      if (nameExists) {
        alert('Name already exists.');
        return;
      }

      this.props.onRenameDesign({ id, name });
    };

    const handleDelete = (id: number) => {
      const record = this.props.data.get(id);
      if (!record) return;
      if (
        confirm(`Are you sure you want to delete the design "${record.name}"?`)
      ) {
        this.props.onDeleteDesign(id);
      }
    };

    const handleCopy = (id: number) => {
      const record = this.props.data.get(id);
      if (!record) return;

      const newRecordName = `${record.name}-${new Date().toISOString()}`;

      const nameExists = Array.from(this.props.data).some(
        ([, r]) => r.name.toUpperCase() === newRecordName.toUpperCase(),
      );

      if (nameExists) {
        alert('Name already exists.');
        return;
      }

      this.props.onCopyDesign({ id, name: newRecordName });
    };

    const loadingOrContent = () => {
      if (this.props.loading) return <h3>Loading...</h3>;

      if (this.props.data.size === 0)
        return <div>There were no previously saved designs found.</div>;

      return (
        <FileManagement
          data={this.props.data}
          onHandleClick={handleOnOpen}
          onHandleRename={handleRename}
          onHandleDelete={handleDelete}
          onHandleCopy={handleCopy}
        />
      );
    };

    return (
      <Modal isOpen={this.props.show} toggle={toggle}>
        <ModalHeader toggle={toggle}>My Designs</ModalHeader>
        <ModalBody className="row">
          <Col sm={12} className={classes.scrollable}>
            {loadingOrContent()}
          </Col>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.global.records.loading,
    data: state.global.records.data,
  };
}

function mapDispatchToProps(dispatch: AppDispatch): {} {
  return {
    onOpenDesign: id => dispatch(actions.fetchRecord(id)),
    onRenameDesign: (id, name) => dispatch(actions.updateRecordName(id, name)),
    onCopyDesign: (id, name) => dispatch(actions.copyDesign(id, name)),
    onDeleteDesign: id => dispatch(actions.deleteDesign(id)),
  };
}

const enhancer = compose(connect(mapStateToProps, mapDispatchToProps));

export default enhancer(OpenDesignModal);



// WEBPACK FOOTER //
// ./src/components/OpenDesignModal/OpenDesignModal.js